import React, { useState, useMemo } from 'react';
import SearchConditionStyled from './SearchConditionStyled';
import { useForm } from 'react-hook-form';
import {
  Box,
  FormControl,
  // MenuItem,
  // Select,
  // InputLabel,
  // TextField,
  Button,
  useTheme,
} from '@material-ui/core';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
// import ClearIconML from '@/components/ClearIconML/index';
import AutoComplateML from '@/components/AutoComplateML';
// import DateRangePickerML from '@/components/DateRangePickerML';

const SearchCondition = (props) => {
  // const dispatch = useDispatch();
  const { query } = props;
  const { handleSearch, restClick } = props;
  const {
    signUpDateEnd,
    signUpDateStart,
    registerStore: RegisterStore,
  } = query;
  const theme = useTheme();
  const { handleSubmit } = useForm({
    defaultValues: {
      date: { startDate: signUpDateStart, endDate: signUpDateEnd },
    },
  });

  // 状态保持时注册门店和服务门店
  const defaultRegisterStore = useMemo(() => {
    let RegisterStoreArray = [];
    if (RegisterStore) {
      RegisterStoreArray = RegisterStore.split('-');
    }
    return RegisterStoreArray;
  }, [RegisterStore]);

  const [rsValue, setRsValue] = useState([]);

  //点击重置
  const resetData = () => {
    setRsValue([]);
    const propsResetSearch = {
      registerStore: '',
    };
    restClick && restClick(propsResetSearch);
  };

  //查询
  const handleSubmitSuccess = (submitData) => {
    const registerStore = rsValue?.join('-');
    const propsSubmitData = {
      ...submitData,
      registerStore,
      isSearch: true,
    };
    delete propsSubmitData.date;
    handleSearch && handleSearch(propsSubmitData);
  };

  return (
    <SearchConditionStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <div className="search-condition-wrap">
          <div className="card-content-wrap">
            <FormControl variant="standard" className="single-select">
              <AutoComplateML
                label={'活动门店'}
                defaultValue={defaultRegisterStore}
                selectedId={rsValue}
                setSelectedId={setRsValue}
              />
            </FormControl>
            {/* <FormControl variant="standard" className="single-select">
              <Controller
                render={(rp) => (
                  <DateRangePickerML
                    // label="注册日期"
                    startText="开始日期"
                    endText="结束日期"
                    defaultStartDate={
                      signUpDateStart === undefined
                        ? dayjs().format('YYYY-MM-DD')
                        : signUpDateStart
                    }
                    defaultEndDate={
                      signUpDateEnd === undefined
                        ? dayjs().format('YYYY-MM-DD')
                        : signUpDateEnd
                    }
                    rp={rp}
                    onChange={({ startDate, endDate }) => {
                      handleSearch({
                        signUpDateStart: startDate,
                        signUpDateEnd: endDate,
                        isSearch: 'false',
                      });
                      setIsReset(false);
                    }}
                    name="custom-form-submit-name"
                    isReset={isReset}
                  />
                )}
                name="date"
                control={control}
              />
            </FormControl> */}
          </div>
          {/* 按钮 */}
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              type="reset"
              className="reset"
              onClick={() => resetData()}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              重置
            </Button>
            <Button
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              查询
            </Button>
          </Box>
        </div>
      </form>
    </SearchConditionStyled>
  );
};

export default SearchCondition;
